package gr.tech.GRAttestation.models.tables

import gr.tech.GRAttestation.util.todayString
import kotlinx.serialization.Serializable

@Serializable
data class BasicTableFilters(
    var dateColumn: String = "createdAt",
    var isAscending: Boolean = false,
    var isBefore: Boolean = true,
    var dateString: String = todayString
)
